import { createSlice } from "@reduxjs/toolkit";
import { PROJECT_TYPE } from "../../constants/constant";
import { users } from "../../constants/ssodummy";

export const projectSlice = createSlice({
  name: "project",
  initialState: {
    totalProjects: 0,
    archiveProjects: 0,
    archiveProjectsData: [],
    projectsData: [],
    users: [],
    // users: users.globeruser,
    currentProjectDetail: {},
    currentMVOCDetail: {},
    mvocdetails:{},
    moa: [],
    currentProjectScopeType: "",
    currentProjectScopeDetail: {},
    selectedProjectRow: [],
    selectedTab: "my projects",
    selectedInsight:"",
    stepCompleted:0,
    currentFormValues: {
      asset_name: '',
      indication_name: ''
    },
  },
  reducers: {
    setStepcompleted: (state, action) => {
        state.stepCompleted = action.payload;
    },
    setProjectData: (state, action) => {
        state.projectsData = action.payload;
    },
    setTotalProjects: (state, action) => {
        state.totalProjects = action.payload;
    },
    setArchiveProjectData: (state, action) => {
        state.archiveProjectsData = action.payload;
    },
    setTotalArchiveProjects: (state, action) => {
        state.archiveProjects = action.payload;
    },
    setSelectedProjectRow: (state, action) => {
        state.selectedProjectRow = action.payload;
    },
    setUsers: (state, action) => {
        state.users = action.payload
    },
    setCurrentProjectDetail: (state, action) => {
        state.currentProjectDetail = action.payload;
    },
    setCurrentMVOCDetail: (state, action) => {
        state.currentMVOCDetail = action.payload;
    },
    resetCurrentMVOCDetail: (state) => {
        state.currentMVOCDetail = {};
    },
    resetCurrentProjectDetail: (state) => {
        state.currentProjectDetail = {};
    },
    setMoaSelectedData: (state, action) => {
        state.moa = action.payload
    },
    setCurrentProjectScopeType: (state, action) => {
        state.currentProjectScopeType = action.payload
    },
    setSelectedInsight: (state, action) => {
        state.selectedInsight = action.payload
    },
    setSelectedtab: (state, action) => {
        state.selectedTab = action.payload
    },
    toggleProjectLock: (state, action) => {
        const { projectId, response, activeTab } = action.payload; // Get projectId and response
        console.log("projectId1234", projectId, response, activeTab)
        // Determine which list to update based on activeTab
        const targetDataKey = activeTab === 'ARCHIVED' ? 'archiveProjectsData' : 'projectsData';
        // Update the target data array
        state[targetDataKey] = state[targetDataKey].map((project) =>
            // console.log("project", project)
            project.id === projectId
                ? {
                    ...project,
                    project_lock_user_id:
                        project.project_lock_user_id === null
                            ? response?.result?.userId?.result 
                            : null,
                }
                : project
        );
    },
    updateFormValues: (state, action) => {
      state.currentFormValues = {
        ...state.currentFormValues,
        ...action.payload
      };
    },
  },
});

export const {setProjectData, setCurrentProjectDetail, setTotalProjects, setUsers, setMoaSelectedData, setCurrentProjectScopeType, setArchiveProjectData, setTotalArchiveProjects, setSelectedProjectRow, setSelectedtab, toggleProjectLock,setStepcompleted,resetCurrentProjectDetail,setSelectedInsight,setCurrentMVOCDetail,resetCurrentMVOCDetail,updateFormValues} = projectSlice.actions;

export default projectSlice.reducer;
